import moment from 'moment'

export default {
    state: {
        data: [],
        loadingData: false,
        clientesData: [],
        loadingClientesData: false,
        loadingAutorizaNega: false,
        snackBar: {
            visible: false,
            message: ''
        },

    },
    mutations: {
        setAcessoRealtecData(state, payload) {
            state.data = payload
        },
        setAcessoRealtecDataNew(state, payload) {
            const acRealContador = payload.ACREALCONTADOR

            state.data.unshift({...payload,
                new: true
            })

            setTimeout(function() {
                    state.data.forEach(_acessoRealtec => {
                        if (_acessoRealtec.ACREALCONTADOR == acRealContador) {
                            if (_acessoRealtec.new) {
                                _acessoRealtec.new = false
                            }

                        }
                    })
                }, 300000) // 5 min
        },
        setAcessoRealtecLoadingData(state, payload) {
            state.loadingData = payload
        },
        setAcessoRealtecClientesData(state, payload) {
            state.clientesData = payload
        },
        setAcessoRealtecLoadingClientesData(state, payload) {
            state.loadingClientesData = payload
        },
        setAcessoRealtecAutorizaNegaData(state, payload) {
            state.data.forEach(_acessoRealtec => {
                if (_acessoRealtec.ACREALCONTADOR == Number(payload.ACREALCONTADOR)) {
                    _acessoRealtec.ACREALSITUACAO = payload.ACREALSITUACAO
                    _acessoRealtec.ACREALAUTORIZACAO = moment()
                    _acessoRealtec.ACREALOBSERVACAO = payload.ACREALOBSERVACAO
                    _acessoRealtec.USUCODIGO = payload.USUCODIGO
                    if (_acessoRealtec.new)
                        delete _acessoRealtec.new
                }
            });
        },
        setAcessoRealtecEncerradoData(state, payload) {
            state.data.forEach(_acessoRealtec => {
                if (_acessoRealtec.ACREALCONTADOR == Number(payload.ACREALCONTADOR)) {
                    _acessoRealtec.ACREALSITUACAO = payload.ACREALSITUACAO
                    _acessoRealtec.ACREALENCERRAMENTO = moment()
                    if (_acessoRealtec.new)
                        delete _acessoRealtec.new
                }
            });
        },
        setAcessoRealtecLoadingAutorizaNega(state, payload) {
            state.loadingAutorizaNega = payload
        },
        setAcessoRealtecSnackBar(state, payload) {
            state.snackBar.visible = payload.visible
            state.snackBar.message = payload.message
            state.snackBar.color = payload.color
        },
    },
    actions: {
        setAcessoRealtecData({ commit }, payload) {
            commit('setAcessoRealtecData', payload)
        },
        setAcessoRealtecDataNew({ commit }, payload) {
            commit('setAcessoRealtecDataNew', payload)
        },
        setAcessoRealtecLoadingData({ commit }, payload) {
            commit('setAcessoRealtecLoadingData', payload)
        },
        setAcessoRealtecClientesData({ commit }, payload) {
            commit('setAcessoRealtecClientesData', payload)
        },
        setAcessoRealtecLoadingClientesData({ commit }, payload) {
            commit('setAcessoRealtecLoadingClientesData', payload)
        },
        setAcessoRealtecAutorizaNegaData({ commit }, payload) {
            commit('setAcessoRealtecAutorizaNegaData', payload)
        },
        setAcessoRealtecEncerradoData({ commit }, payload) {
            commit('setAcessoRealtecEncerradoData', payload)
        },
        setAcessoRealtecLoadingAutorizaNega({ commit }, payload) {
            commit('setAcessoRealtecLoadingAutorizaNega', payload)
        },
        setAcessoRealtecSnackBar({ commit }, payload) {
            commit('setAcessoRealtecSnackBar', payload)
        },
    }
}